import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Space, Tabs, TabsProps, message } from 'antd';
import Header from '@components/Comman/Header';
import Referrals from '../Referrals/Referrals';
import MyReferrers from '../MyReferrer/MyReferrer';
import PageTitle from '@components/Comman/PageTitle';
import { useDispatch } from 'react-redux';
import { businessDetailsById } from '../../actions/business';
import { Descriptions, Card, Button, Image } from 'antd';
import { CopyOutlined } from '@ant-design/icons';


const BusinessDetails = () => {
    const [activeStep, setActiveStep] = useState("1");
    const location = useLocation();
    const [ data, setData ] = useState<any>({});
    let stateData = location?.state;
    const dispatch = useDispatch();
    const [showTabs, setShowTabs] = useState(false);

    const onChange = (key: string) => {
        setActiveStep(key)
    };

    const tabItemProps = {
        adminId: stateData?.adminId
    }



    const handleCopy = (url:string) => {
        navigator.clipboard.writeText(url)
          .then(() => {
            message.success('URL copied to clipboard!');
          })
          .catch(() => {
            message.error('Failed to copy URL');
          });
      };

    const { TabPane } = Tabs;

    useEffect(() => {
        dispatch(
            businessDetailsById(tabItemProps?.adminId, (resp: any) => {                
                if(resp?.status === 200) {
                    setData(resp?.data);
                }
            })
        );
    }, []);
    console.log(data, "...............dfgdfgh........");
    

    return (
        <div>
            <Header pagTitle="Business Details" />
            <div className="contentBody">
                <div className="bodycard">
                    <PageTitle buttonLabel='Back' pagTitle={data?.businessName} button={true} buttonLink={'/super-admin/all-businesses'} />
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Business Details" key="1">
                        <Card>
                            {data?.logoUrl && (
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                   <Image width={200} src={data?.logoUrl} alt="Business Logo" />
                                </div>
                            )}

                            {/* Business Details */}
                            <Descriptions bordered column={1}>
                                <Descriptions.Item label="Business Name">{data?.businessName}</Descriptions.Item>
                                <Descriptions.Item label="Category">{data?.category}</Descriptions.Item>
                                <Descriptions.Item label="Contact Person">{data?.contactPerson}</Descriptions.Item>
                                <Descriptions.Item label="Contact Number">{data?.contactNumber}</Descriptions.Item>
                                <Descriptions.Item label="Contact Email">{data?.Admin?.email}</Descriptions.Item>
                                <Descriptions.Item label="Address">{data?.address}</Descriptions.Item>
                                <Descriptions.Item label="Description">{data?.description}</Descriptions.Item>
                                <Descriptions.Item label="Website">
                                    {data?.url ? (
                                    <Space>
                                        <a href={data.url} target="_blank" rel="noopener noreferrer">
                                        {data.url}
                                        </a>
                                        <Button
                                        type="link"
                                        icon={<CopyOutlined />}
                                        onClick={() => handleCopy(data.url)}
                                        >
                                        Copy URL
                                        </Button>
                                    </Space>
                                    ) : (
                                    "N/A"
                                    )}
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>
                        </TabPane>
                        <TabPane tab="All Referrals" key="2">
                            <div className="cardContentbody" style={{ marginTop: '20px' }}>
                              <Referrals {...tabItemProps} />
                            </div>
                        </TabPane>
                        <TabPane tab="All Referrers" key="3">
                            <div className="cardContentbody" style={{ marginTop: '20px' }}>
                               <MyReferrers {...tabItemProps} />
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </div>
    );
};

export default BusinessDetails;

